/** Keys from layer.config that are persisted on saved map artefacts. */
export const PERSISTABLE_LAYER_CONFIG_KEYS = [
  'palette',
  'inverted',
  'colorProperty',
  'uniformColor',
  'highCardinalityCategorical',
  'classificationMethod',
  'numClasses',
  'classBreaks',
];

export function extractPersistableLayerConfig(config = {}) {
  if (!config || typeof config !== 'object') return {};
  const result = {};
  for (const key of PERSISTABLE_LAYER_CONFIG_KEYS) {
    if (config[key] !== undefined) {
      result[key] = config[key];
    }
  }
  return result;
}

/**
 * Build the runtime layer.config from saved artefact config and freshly computed defaults.
 */
export function mergeSavedLayerConfig(savedConfig = {}, computed = {}) {
  const saved = extractPersistableLayerConfig(savedConfig);
  const merged = { ...computed };

  for (const key of PERSISTABLE_LAYER_CONFIG_KEYS) {
    if (saved[key] !== undefined) {
      merged[key] = saved[key];
    }
  }

  return merged;
}
